// A candidate's confidence as words, never a bare decimal: the same rule the design brief sets for
// blind-mode deduction, reused for scan-match confidence.
import "./config";
import { useT } from "../lib/i18n";
import { Status } from "./surfaces";

export function confidenceLevel(score: number): "strong" | "likely" | "possible" {
  if (score >= 0.85) return "strong";
  if (score >= 0.65) return "likely";
  return "possible";
}

const TONE = { strong: "ok", likely: "accent", possible: "wait" } as const;

export function ConfidenceBadge({ confidence }: { confidence: number }): React.JSX.Element {
  const { t } = useT();
  const level = confidenceLevel(confidence);
  return (
    <Status tone={TONE[level]} flexShrink={0}>
      {t(`confidence.${level}.label`)}
    </Status>
  );
}
